const networkData = [
  {
    id: 1,
    name: "Orange Côte d'Ivoire",
    logo: "/logo-orange.jpg",
    syntaxes: [
      {
        id: 1,
        title: "Consulter mon compte principal",
        content: "Pour consulter votre compte principal, composez #122#.",
        category: "Consultation",
        operationType: "Compte Principal"
      },
      {
        id: 2,
        title: "Consulter mon volume internet",
        content: "Pour consulter votre volume internet, composez #149*32#.",
        category: "Consultation",
        operationType: "Internet"
      },
      {
        id: 3,
        title: "Modifier mon profil Compte Prépayé",
        content: "Pour modifier votre profil Compte Prépayé, composez #121#.",
        category: "Modification",
        operationType: "Compte Prépayé"
      },
      {
        id: 4,
        title: "Accéder au Portail Orange",
        content: "Pour accéder au Portail Orange, composez #124#.",
        category: "Accès",
        operationType: "Portail"
      },
      {
        id: 5,
        title: "Connaitre mon numéro Orange",
        content: "Pour connaître votre numéro Orange, composez #99#.",
        category: "Consultation",
        operationType: "Numéro"
      },
      {
        id: 6,
        title: "Gérer mes Numéros Préférés",
        content: "Pour gérer vos Numéros Préférés, composez #221#.",
        category: "Gestion",
        operationType: "Numéros Préférés"
      },
      {
        id: 7,
        title: "Connaître mon Code PUK",
        content: "Pour connaître votre Code PUK, composez #124*61#.",
        category: "Consultation",
        operationType: "Code PUK"
      },
      {
        id: 8,
        title: "Transférer du crédit",
        content: "Pour transférer du crédit, composez #124*34#.",
        category: "Transfert",
        operationType: "Crédit"
      },
      {
        id: 9,
        title: "Se dépanner (SOS crédit)",
        content: "Pour vous dépanner (SOS crédit), composez #170#.",
        category: "Dépannage",
        operationType: "Crédit"
      },
      {
        id: 10,
        title: "Gérer mon compte Orange Money",
        content: "Pour gérer votre compte Orange Money, composez #144#.",
        category: "Gestion",
        operationType: "Orange Money"
      },
      {
        id: 11,
        title: "Payer ma facture via Orange Money",
        content: "Pour payer votre facture via Orange Money, composez #144*2#.",
        category: "Paiement",
        operationType: "Facture"
      },
      {
        id: 12,
        title: "Acheter du crédit via Orange Money",
        content: "Pour acheter du crédit via Orange Money, composez #144*3#.",
        category: "Achat",
        operationType: "Crédit"
      },
      {
        id: 13,
        title: "Transférer de l'argent via Orange Money",
        content: "Pour transférer de l'argent via Orange Money, composez #144*1#.",
        category: "Transfert",
        operationType: "Argent"
      },
      {
        id: 14,
        title: "Souscrire à un Pass TV",
        content: "Pour souscrire à un Pass TV, composez #101#.",
        category: "Souscription",
        operationType: "TV"
      },
      {
        id: 15,
        title: "Accéder à la liste des Pharmacies de garde",
        content: "Pour accéder à la liste des Pharmacies de garde, composez #127#.",
        category: "Accès",
        operationType: "Pharmacies"
      },
      {
        id: 16,
        title: "Transfert data et Family data",
        content: "Pour le transfert data et Family data, composez #222#.",
        category: "Transfert",
        operationType: "Data"
      },
      {
        id: 17,
        title: "Consultation du volume Flybox",
        content: "Pour consulter le volume Flybox, composez #144*453*3#.",
        category: "Consultation",
        operationType: "Flybox"
      },
      {
        id: 18,
        title: "Menu principal de la TV d'Orange",
        content: "Pour accéder au menu principal de la TV d'Orange, composez #101#.",
        category: "Accès",
        operationType: "TV"
      },
      {
        id: 19,
        title: "Créer un compte TV",
        content: "Pour créer un compte TV, composez #101*2#.",
        category: "Création",
        operationType: "TV"
      },
      {
        id: 20,
        title: "Recharger son compte VOD",
        content: "Pour recharger votre compte VOD, composez #101*3#.",
        category: "Rechargement",
        operationType: "VOD"
      },
      {
        id: 21,
        title: "Acheter un pass TV",
        content: "Pour acheter un pass TV, composez #101*4#.",
        category: "Achat",
        operationType: "TV"
      },
      {
        id: 22,
        title: "Consulter mon solde TV",
        content: "Pour consulter votre solde TV, composez #101*5#.",
        category: "Consultation",
        operationType: "TV"
      },
      {
        id: 23,
        title: "Gérer ses codes TV",
        content: "Pour gérer vos codes TV, composez #101*6#.",
        category: "Gestion",
        operationType: "TV"
      },
      {
        id: 24,
        title: "Achat de pass internet",
        content: "Pour acheter un pass internet, composez #149*31# ou #111*12#.",
        category: "Achat",
        operationType: "Internet"
      },
      {
        id: 25,
        title: "Consulter son solde internet",
        content: "Pour consulter votre solde internet, composez #149*32# ou #111*22#.",
        category: "Consultation",
        operationType: "Internet"
      },
      {
        id: 26,
        title: "Achat de pass pour un tiers",
        content: "Pour acheter un pass pour un tiers, composez #149*33# ou #111*32#.",
        category: "Achat",
        operationType: "Internet"
      },
      {
        id: 27,
        title: "Paramètre internet",
        content: "Pour accéder aux paramètres internet, composez #124*64#.",
        category: "Accès",
        operationType: "Internet"
      },
      {
        id: 28,
        title: "Souscrire à un pass Mix",
        content: "Pour souscrire à un pass Mix, composez #111*11#.",
        category: "Souscription",
        operationType: "Mix"
      },
      {
        id: 29,
        title: "Consulter mes avantages Pass Mix",
        content: "Pour consulter vos avantages Pass Mix, composez #111*21#.",
        category: "Consultation",
        operationType: "Mix"
      },
      {
        id: 30,
        title: "Achat de pass Mix pour un tiers",
        content: "Pour acheter un pass Mix pour un tiers, composez #111*31#.",
        category: "Achat",
        operationType: "Mix"
      },
      {
        id: 31,
        title: "Souscription Togo Togo",
        content: "Pour souscrire à Togo Togo, composez #117# ou #144*38#.",
        category: "Souscription",
        operationType: "Togo Togo"
      },
      {
        id: 32,
        title: "Souscription Togo Togo via Orange Money",
        content: "Pour souscrire à Togo Togo via Orange Money, composez #144*34#.",
        category: "Souscription",
        operationType: "Togo Togo"
      },
      {
        id: 33,
        title: "Migration Togo Togo",
        content: "Pour migrer vers Togo Togo, composez #117# ou #121#.",
        category: "Migration",
        operationType: "Togo Togo"
      },
      {
        id: 34,
        title: "Souscrire à un pass voyage",
        content: "Pour souscrire à un pass voyage, composez #124*523#.",
        category: "Souscription",
        operationType: "Voyage"
      },
      {
        id: 35,
        title: "Souscrire à un pass international",
        content: "Pour souscrire à un pass international, composez #124*51#.",
        category: "Souscription",
        operationType: "International"
      },
      {
        id: 36,
        title: "Accéder aux tarifs roaming",
        content: "Pour accéder aux tarifs roaming, composez #124*52#.",
        category: "Accès",
        operationType: "Roaming"
      }
    ]
  },
  {
    id: 2,
    name: "MTN Côte d'Ivoire",
    logo: "/logo-mtn.jpg",
    syntaxes: [
      {
        id: 1,
        title: "Connaître mon numéro",
        content: "Pour connaître votre numéro, composez *99#.",
        category: "Consultation",
        operationType: "Numéro"
      },
      {
        id: 2,
        title: "Configurer mon téléphone à internet",
        content: "Pour configurer votre téléphone à internet, envoyez 'paramètre' par SMS au 500.",
        category: "Configuration",
        operationType: "Internet"
      },
      {
        id: 3,
        title: "Récupérer mon code PUK",
        content: "Pour récupérer votre code PUK, composez le 5552 à partir d'un autre numéro MTN.",
        category: "Assistance",
        operationType: "Code PUK"
      },
      {
        id: 4,
        title: "Transférer du crédit",
        content: "Pour transférer du crédit, composez *111*numéro du destinataire*montant à transférer*Votre code secret#.",
        category: "Transfert",
        operationType: "Crédit"
      },
      {
        id: 5,
        title: "Biper sans unités",
        content: "Pour biper sans unités, composez *102*le numéro à biper*0#.",
        category: "Communication",
        operationType: "Bip"
      },
      {
        id: 6,
        title: "Souscrire à un Pack",
        content: "Pour souscrire à un Pack MTN Free, Pack Internet ou Pack SMS, composez *105#.",
        category: "Souscription",
        operationType: "Pack"
      },
      {
        id: 7,
        title: "Contacter le service client",
        content: "Pour contacter le service client, appelez le 555 ou utilisez Ayoba au +2250584555555.",
        category: "Assistance",
        operationType: "Service Client"
      },
      {
        id: 8,
        title: "Changement de numéro sécurisé (Swap sans pré-configuration)",
        content: "Pour un changement de numéro sécurisé sans pré-configuration, composez *550#.",
        category: "Gestion",
        operationType: "Changement de numéro"
      },
      {
        id: 9,
        title: "Changement de numéro sécurisé (pré-configuration & swap après 72h)",
        content: "Pour un changement de numéro sécurisé avec pré-configuration, composez *550#.",
        category: "Gestion",
        operationType: "Changement de numéro"
      },
      {
        id: 10,
        title: "Souscrire aux Packs MTN Free",
        content: "Pour souscrire aux Packs MTN Free, composez *105*1#.",
        category: "Souscription",
        operationType: "Pack Free"
      },
      {
        id: 11,
        title: "Pack Internet",
        content: "Pour accéder aux options de Pack Internet, composez *105*2#.",
        category: "Souscription",
        operationType: "Pack Internet"
      },
      {
        id: 12,
        title: "Pack SMS",
        content: "Pour souscrire à un Pack SMS, composez *105*3#.",
        category: "Souscription",
        operationType: "Pack SMS"
      },
      {
        id: 13,
        title: "Profils prépayés MTN",
        content: "Pour consulter votre profil prépayé MTN, composez *105*4#.",
        category: "Consultation",
        operationType: "Profil"
      },
      {
        id: 14,
        title: "Numéros complices",
        content: "Pour gérer vos numéros complices, composez *105*5#.",
        category: "Gestion",
        operationType: "Numéros complices"
      },
      {
        id: 15,
        title: "Offres promotionnelles",
        content: "Pour découvrir les offres promotionnelles, composez *105*7#.",
        category: "Consultation",
        operationType: "Promotions"
      },
      {
        id: 16,
        title: "MTN Play",
        content: "Pour accéder à MTN Play, composez *105*9#.",
        category: "Divertissement",
        operationType: "MTN Play"
      },
      {
        id: 17,
        title: "Enregistrer numéro complice",
        content: "Pour enregistrer un numéro complice, composez *105*5*4#.",
        category: "Gestion",
        operationType: "Numéros complices"
      },
      {
        id: 18,
        title: "Remplacer un numéro complice",
        content: "Pour remplacer un numéro complice, composez *105*5*5#.",
        category: "Gestion",
        operationType: "Numéros complices"
      },
      {
        id: 19,
        title: "Consulter liste de numéros complices",
        content: "Pour consulter votre liste de numéros complices, composez *105*5*3#.",
        category: "Consultation",
        operationType: "Numéros complices"
      },
      {
        id: 20,
        title: "Voir la consommation du mois",
        content: "Pour vérifier votre consommation du mois, composez *105*5*2#.",
        category: "Consultation",
        operationType: "Consommation"
      },
      {
        id: 21,
        title: "Souscrire aux Forfaits jour, semaine ou mois",
        content: "Pour souscrire à des forfaits internet, composez *105*2#.",
        category: "Souscription",
        operationType: "Forfait Internet"
      },
      {
        id: 22,
        title: "MENU MTN RECOMPENSE",
        content: "Pour accéder au menu MTN Récompense, composez *150#.",
        category: "Fidélité",
        operationType: "Récompenses"
      },
      {
        id: 23,
        title: "MENU MTN MOBILE MONEY",
        content: "Pour accéder aux services MTN Mobile Money, composez *133#.",
        category: "Services financiers",
        operationType: "Mobile Money"
      },
      {
        id: 24,
        title: "MTN RELIGION SMS",
        content: "Pour accéder aux services religieux, composez *108#.",
        category: "Services",
        operationType: "Religion"
      },
      {
        id: 25,
        title: "AU FEMININ",
        content: "Pour accéder aux contenus féminins, composez *112#.",
        category: "Services",
        operationType: "Contenu féminin"
      },
      {
        id: 26,
        title: "MTN DETENTE",
        content: "Pour accéder aux services de divertissement, composez *113#.",
        category: "Divertissement",
        operationType: "Détente"
      },
      {
        id: 27,
        title: "MTN INFOS",
        content: "Pour accéder aux informations, composez *420#.",
        category: "Services",
        operationType: "Informations"
      },
      {
        id: 28,
        title: "MTN SANTE",
        content: "Pour obtenir des conseils sur la santé, composez *421#.",
        category: "Services",
        operationType: "Santé"
      },
      {
        id: 29,
        title: "INFO SPORT",
        content: "Pour accéder aux informations sportives, composez *422#.",
        category: "Services",
        operationType: "Sport"
      },
      {
        id: 30,
        title: "MTN CONSEILS PRATIQUES",
        content: "Pour obtenir des conseils pratiques, composez *423#.",
        category: "Services",
        operationType: "Conseils"
      },
      {
        id: 31,
        title: "MTN EDUCATION",
        content: "Pour accéder à des ressources éducatives, composez *424#.",
        category: "Services",
        operationType: "Education"
      },
      {
        id: 32,
        title: "Service Plus",
        content: "Pour accéder aux services supplémentaires, composez *105*9*2#.",
        category: "Services",
        operationType: "Services supplémentaires"
      },
      {
        id: 33,
        title: "Transférer du crédit",
        content: "Pour transférer du crédit, composez *111*numéro du destinataire*montant à transférer*Votre code secret#.",
        category: "Transfert",
        operationType: "Crédit"
      },
      {
        id: 34,
        title: "Rappelle-Moi",
        content: "Pour demander à un autre utilisateur de vous rappeler, composez *102*[numéro du destinataire]#.",
        category: "Communication",
        operationType: "Rappel"
      },
      {
        id: 35,
        title: "Envoie-Moi du crédit",
        content: "Pour demander du crédit à un autre utilisateur, composez *102*[numéro du destinataire]*1#.",
        category: "Transfert",
        operationType: "Demande de crédit"
      },
      {
        id: 36,
        title: "Connaitre son Profil",
        content: "Pour vérifier votre profil, composez *120#.",
        category: "Consultation",
        operationType: "Profil"
      },
      {
        id: 37,
        title: "Pour afficher l'IMEI",
        content: "Pour afficher l'IMEI de votre téléphone, composez *#06#.",
        category: "Consultation",
        operationType: "IMEI"
      },
      {
        id: 38,
        title: "Pour avoir le solde",
        content: "Pour vérifier le solde de votre compte, composez #100#.",
        category: "Consultation",
        operationType: "Solde"
      },
      {
        id: 39,
        title: "Pour recharger le compte",
        content: "Pour recharger votre compte, composez *100*[les 14 chiffres de la carte de recharge]#.",
        category: "Rechargement",
        operationType: "Crédit"
      },
      {
        id: 40,
        title: "Trouver une agence à proximité",
        content: "Pour localiser une agence MTN, composez *225*3#.",
        category: "Services",
        operationType: "Localisation d'agence"
      }
    ]
  },
  {
    id: 3,
    name: "Moov Africa Côte d'Ivoire",
    logo: "/logo-moov.jpeg",
    syntaxes: [
      {
        id: 1,
        title: "Acheter un forfait appel Izy heures+",
        content: "Pour acheter un forfait appel Izy heures+, composez *303*1#.",
        category: "Souscription",
        operationType: "Forfait Appel"
      },
      {
        id: 2,
        title: "Consulter mes avantages Izy heures+",
        content: "Pour consulter vos avantages Izy heures+, composez *505*6#.",
        category: "Consultation",
        operationType: "Avantages"
      },
      {
        id: 3,
        title: "Forfait Moov Folie Nuit",
        content: "Pour souscrire au forfait Moov Folie Nuit, composez *303*2*1*7#.",
        category: "Souscription",
        operationType: "Forfait Nuit"
      },
      {
        id: 4,
        title: "Acheter un pass Internet",
        content: "Pour acheter un pass Internet, composez *303*3*1#.",
        category: "Souscription",
        operationType: "Pass Internet"
      },
      {
        id: 5,
        title: "Consulter mon volume internet (Mon numéro)",
        content: "Pour consulter votre volume internet (Mon numéro), composez *303*3*2*1#.",
        category: "Consultation",
        operationType: "Volume Internet"
      },
      {
        id: 6,
        title: "Consulter mon volume internet (Pocket wifi ou Box 4G)",
        content: "Pour consulter votre volume internet (Pocket wifi ou Box 4G), composez *303*3*2*1#.",
        category: "Consultation",
        operationType: "Volume Internet"
      },
      {
        id: 7,
        title: "Achat de pass pour un tiers",
        content: "Pour acheter un pass pour un tiers, composez *303*3*4#.",
        category: "Souscription",
        operationType: "Pass Tiers"
      },
      {
        id: 8,
        title: "Acheter un forfait Moov Folie",
        content: "Pour acheter un forfait Moov Folie, composez *303*2#.",
        category: "Souscription",
        operationType: "Forfait Moov Folie"
      },
      {
        id: 9,
        title: "Connaître mon profil",
        content: "Pour connaître votre profil, composez *505*5#.",
        category: "Consultation",
        operationType: "Profil"
      },
      {
        id: 10,
        title: "Gérer mes Numéros Préférés",
        content: "Pour gérer vos Numéros Préférés, composez *107#.",
        category: "Gestion",
        operationType: "Numéros Préférés"
      },
      {
        id: 11,
        title: "Connaître mon Code PUK",
        content: "Pour connaître votre Code PUK, composez *388#.",
        category: "Consultation",
        operationType: "Code PUK"
      },
      {
        id: 12,
        title: "Connaître son statut d'identification",
        content: "Pour connaître votre statut d'identification, composez *338#.",
        category: "Consultation",
        operationType: "Statut Identification"
      },
      {
        id: 13,
        title: "Connaître mon numéro",
        content: "Pour connaître votre numéro, composez *106#.",
        category: "Consultation",
        operationType: "Numéro"
      },
      {
        id: 14,
        title: "Souscrire à un forfait SMS",
        content: "Pour souscrire à un forfait SMS, composez *366#.",
        category: "Souscription",
        operationType: "Forfait SMS"
      },
      {
        id: 15,
        title: "Rappel moi",
        content: "Pour demander un rappel, composez *108*numéro#.",
        category: "Communication",
        operationType: "Rappel"
      },
      {
        id: 16,
        title: "Transfert d'unité",
        content: "Pour transférer des unités, composez *102*montant*numero de téléphone*code secret#.",
        category: "Transfert",
        operationType: "Unités"
      },
      {
        id: 17,
        title: "Moov crédit secours",
        content: "Pour vous dépanner avec Moov crédit secours, composez *444#.",
        category: "Dépannage",
        operationType: "Crédit Secours"
      },
      {
        id: 18,
        title: "Paiement de facture CIE via Moov Money",
        content: "Pour payer votre facture CIE via Moov Money, composez *155*4*1*1#.",
        category: "Paiement",
        operationType: "Facture CIE"
      },
      {
        id: 19,
        title: "Paiement de facture SODECI via Moov Money",
        content: "Pour payer votre facture SODECI via Moov Money, composez *155*4*2*1#.",
        category: "Paiement",
        operationType: "Facture SODECI"
      },
      {
        id: 20,
        title: "Réabonnement CANAL+ / IROKO+ via Moov Money",
        content: "Pour vous réabonner à CANAL+ / IROKO+ via Moov Money, composez *155*4*3#.",
        category: "Paiement",
        operationType: "Réabonnement TV"
      },
      {
        id: 21,
        title: "Réabonnement EASY TV via Moov Money",
        content: "Pour vous réabonner à EASY TV via Moov Money, composez *155*4*3#.",
        category: "Paiement",
        operationType: "Réabonnement TV"
      },
      {
        id: 22,
        title: "Réabonnement STARTIMES via Moov Money",
        content: "Pour vous réabonner à STARTIMES via Moov Money, composez *155*4*7#.",
        category: "Paiement",
        operationType: "Réabonnement TV"
      },
      {
        id: 24,
        title: "Régler vos achats en magasins via Moov Money",
        content: "Pour régler vos achats en magasins via Moov Money, composez *155*4*4#.",
        category: "Paiement",
        operationType: "Achats Magasins"
      },
      {
        id: 25,
        title: "Participer à une collecte de fonds via Moov Money",
        content: "Pour participer à une collecte de fonds via Moov Money, composez *155*5#.",
        category: "Paiement",
        operationType: "Collecte de Fonds"
      },
      {
        id: 26,
        title: "Payer vos frais d'inscription aux examens et concours via Moov Money",
        content: "Pour payer vos frais d'inscription aux examens et concours via Moov Money, composez *155*7#.",
        category: "Paiement",
        operationType: "Frais d'Inscription"
      },
      {
        id: 27,
        title: "Gérer mon compte Moov Money",
        content: "Pour gérer votre compte Moov Money, composez *155#.",
        category: "Gestion",
        operationType: "Compte Moov Money"
      },
      {
        id: 28,
        title: "Transfert d'argent via Moov Money",
        content: "Pour transférer de l'argent via Moov Money, composez *155*1#.",
        category: "Transfert",
        operationType: "Argent"
      },
      {
        id: 29,
        title: "Consulter le solde Moov Money",
        content: "Pour consulter votre solde Moov Money, composez *155*6#.",
        category: "Consultation",
        operationType: "Solde Moov Money"
      },
      {
        id: 30,
        title: "Recharger du crédit via Moov Money",
        content: "Pour recharger du crédit via Moov Money, composez *155*3*1#.",
        category: "Rechargement",
        operationType: "Crédit"
      },
      {
        id: 31,
        title: "Consulter mon solde Moov Money",
        content: "Pour consulter votre solde Moov Money, composez *155*6#.",
        category: "Consultation",
        operationType: "Solde Moov Money"
      },
      {
        id: 32,
        title: "Appel international",
        content: "Pour effectuer un appel international, composez *303*5#.",
        category: "Communication",
        operationType: "Appel International"
      },
      {
        id: 33,
        title: "Souscrire à un pass international",
        content: "Pour souscrire à un pass international, composez *303*3*6#.",
        category: "Souscription",
        operationType: "Pass International"
      },
      {
        id: 34,
        title: "Transfert d'argent local",
        content: "Pour effectuer un transfert d'argent local, composez *155*1*1#.",
        category: "Transfert",
        operationType: "Argent Local"
      },
      {
        id: 35,
        title: "Transfert d'argent vers un surnom",
        content: "Pour transférer de l'argent vers un surnom, composez *155*1*2#.",
        category: "Transfert",
        operationType: "Argent Surnom"
      },
      {
        id: 36,
        title: "Transfert d'argent international",
        content: "Pour effectuer un transfert d'argent international, composez *155*1*3#.",
        category: "Transfert",
        operationType: "Argent International"
      },
      {
        id: 37,
        title: "Dépôt d'argent",
        content: "Pour effectuer un dépôt d'argent, composez *155*1*4#.",
        category: "Dépôt",
        operationType: "Argent"
      },
      {
        id: 38,
        title: "Transfert de salaire vers Cp",
        content: "Pour transférer un salaire vers Cp, composez *155*1*5#.",
        category: "Transfert",
        operationType: "Salaire"
      },
      {
        id: 39,
        title: "Retrait d'argent chez un agent",
        content: "Pour retirer de l'argent chez un agent, composez *155*2*1#.",
        category: "Retrait",
        operationType: "Argent Agent"
      },
      {
        id: 40,
        title: "Retrait d'argent via code",
        content: "Pour retirer de l'argent via un code, composez *155*2*2#.",
        category: "Retrait",
        operationType: "Argent Code"
      },
      {
        id: 41,
        title: "Retrait de salaire",
        content: "Pour retirer un salaire, composez *155*2*3#.",
        category: "Retrait",
        operationType: "Salaire"
      },
      {
        id: 42,
        title: "Retrait du sous compte commission PDV",
        content: "Pour retirer du sous compte commission PDV, composez *155*2*4#.",
        category: "Retrait",
        operationType: "Commission PDV"
      },
      {
        id: 43,
        title: "Bon d'achat",
        content: "Pour utiliser un bon d'achat, composez *155*2*5#.",
        category: "Paiement",
        operationType: "Bon d'achat"
      },
      {
        id: 44,
        title: "Achat de forfait internet",
        content: "Pour acheter un forfait internet, composez *155*3*2#.",
        category: "Achat",
        operationType: "Forfait Internet"
      },
      {
        id: 45,
        title: "Paiement carburant/gaz",
        content: "Pour payer du carburant ou du gaz, composez *155*3*3#.",
        category: "Paiement",
        operationType: "Carburant/Gaz"
      },
      {
        id: 46,
        title: "Paiement autre commerçant",
        content: "Pour payer un autre commerçant, composez *155*3*4#.",
        category: "Paiement",
        operationType: "Commerçant"
      },
      {
        id: 47,
        title: "Paiement transport",
        content: "Pour payer un service de transport, composez *155*3*5#.",
        category: "Paiement",
        operationType: "Transport"
      },
      {
        id: 48,
        title: "Paiement péage HKB",
        content: "Pour payer le péage HKB, composez *155*3*6#.",
        category: "Paiement",
        operationType: "Péage HKB"
      },
      {
        id: 49,
        title: "Paiement badge HKB",
        content: "Pour payer un badge HKB, composez *155*3*7#.",
        category: "Paiement",
        operationType: "Badge HKB"
      },
      {
        id: 50,
        title: "Paiement assurance",
        content: "Pour payer une assurance, composez *155*3*8#.",
        category: "Paiement",
        operationType: "Assurance"
      },
      {
        id: 51,
        title: "Paiement facture CIE",
        content: "Pour payer une facture CIE, composez *155*4*1#.",
        category: "Paiement",
        operationType: "Facture CIE"
      },
      {
        id: 52,
        title: "Paiement facture SODECI",
        content: "Pour payer une facture SODECI, composez *155*4*2#.",
        category: "Paiement",
        operationType: "Facture SODECI"
      },
      {
        id: 53,
        title: "Paiement factures Moov",
        content: "Pour payer des factures Moov, composez *155*4*5#.",
        category: "Paiement",
        operationType: "Facture Moov"
      },
      {
        id: 54,
        title: "Paiement impôts et taxes",
        content: "Pour payer des impôts et taxes, composez *155*4*6#.",
        category: "Paiement",
        operationType: "Impôts et Taxes"
      },
      {
        id: 55,
        title: "Paiement Burida",
        content: "Pour effectuer un paiement Burida, composez *155*4*8#.",
        category: "Paiement",
        operationType: "Burida"
      },
      {
        id: 56,
        title: "Réabonnement Fibre Moov",
        content: "Pour vous réabonner à la Fibre Moov, composez *155*4*5*2#.",
        category: "Réabonnement",
        operationType: "Fibre Moov"
      }
    ]
  }
];

export default networkData;
